import React, { useState, useEffect } from 'react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("email", email.trim());

      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyP6iq2CCUipVTJts_PH1iIPo0MgsIuRnro9Oj-pJmwRBc9i6frx4dz7vbmb-shiFx8Cg/exec",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.text();

      if (result.toLowerCase().includes("success")) {
        setMessage("Thank you for subscribing!");
        setIsSuccess(true);
        setEmail('');
      } else if (
        result.toLowerCase().includes("already exists") ||
        result.toLowerCase().includes("duplicate") ||
        result.toLowerCase().includes("already subscribed") ||
        result.toLowerCase().includes("already in") ||
        result.toLowerCase().includes("exists already")
      ) {
        setMessage("This email is already subscribed.");
        setIsSuccess(false);
      } else {
        setMessage("Subscription failed. Please try again. Error: " + result);
        setIsSuccess(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("Network error. Please check your connection.");
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => setMessage(''), 6000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">The Healing</h3>
            <p className="text-gray-400">Providing quality healthcare services with compassion and excellence since 2005.</p>
            <div className="flex space-x-4 mt-4">
              <a href="#"><img src="https://img.icons8.com/color/24/000000/facebook-new.png" alt="Facebook" /></a>
              <a href="#"><img src="https://img.icons8.com/color/24/000000/twitter--v1.png" alt="Twitter" /></a>
              <a href="#"><img src="https://img.icons8.com/color/24/000000/instagram-new.png" alt="Instagram" /></a>
              <a href="#"><img src="https://img.icons8.com/color/24/000000/linkedin.png" alt="LinkedIn" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white">Home</a></li>
              <li><a href="/services" className="text-gray-400 hover:text-white">Services</a></li>
              <li><a href="/blog" className="text-gray-400 hover:text-white">Blog</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-white">About</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <address className="text-gray-400 not-italic">
              <p>Wazirganj Gaya</p>
              <p>Bihar India - 803051</p>
              <p className="mt-2">
                Phone: <a href="tel:+919430003381" className="text-blue-400 hover:underline">+91 9430003381</a>
              </p>
              <p>
                Email: <a href="mailto:info@pcds.co.in" className="text-blue-400 hover:underline">info@pcds.co.in</a>
              </p>
              <p className="mt-4">
                Emergency: <a href="tel:+919430003381" className="text-red-400 hover:underline font-semibold">+91 9430003381</a>
              </p>
            </address>
          </div>


          <div>
            <h4 className="text-lg font-semibold mb-4">Newsletter</h4>
            <p className="text-gray-400 mb-4">Subscribe to our newsletter for health tips and updates.</p>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                disabled={isLoading || isSuccess}
              />
              <button
                type="submit"
                disabled={isLoading || isSuccess}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded transition duration-300"
              >
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
            {message && (
              <p className={`mt-2 text-sm ${isSuccess ? 'text-green-400' : message.includes("already subscribed") ? 'text-yellow-400' : 'text-red-400'}`}>
                {message}
              </p>
            )}
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} The Healing  All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
